module.exports = __webpack_public_path__ + "r-v3/img/doc_down_drawing.9722f799.svg";